module.exports = __webpack_public_path__ + "static/img/20017 (1).77a4e11.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20017 (1).webp
// module id = kOsm
// module chunks = 14